import { Button } from "@aircall/ds";
import { useCallback, useMemo, useState } from "react";
import { FloatingButton } from "@/components/FloatingButton/FloatingButton";
import { AutoScrollContext } from "@/providers/AutoScrollContext/AutoScrollProvider";

import { PlaygroundSectionLayout } from "../PlaygroundSectionLayout/PlaygroundSectionLayout";
import { PlaygroundSubSectionLayout } from "../PlaygroundSubSectionLayout/PlaygroundSubSectionLayout";
import { PlaygroundSubSectionTitle } from "../PlaygroundSubSectionTitle/PlaygroundSubSectionTitle";

export function PlaygroundFloatingButton() {
  const [autoScrollEnabled, setAutoScroll] = useState(true);

  const activate = useCallback(() => setAutoScroll(true), []);
  const disable = useCallback(() => setAutoScroll(false), []);

  const context = useMemo(
    () => ({ autoScrollEnabled, activate, disable, setAutoScroll }),
    [autoScrollEnabled, activate, disable]
  );

  return (
    <PlaygroundSectionLayout>
      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>Basic Usage</PlaygroundSubSectionTitle>
        <p className="text-xs font-normal text-muted-foreground">
          A secondary icon-only button used in the transcript view to resume
          autoscroll. It stays hidden while autoscroll is active and only
          appears once autoscroll has been turned off. Hover to reveal the
          tooltip; clicking it resumes autoscroll, which hides the button again.
        </p>
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>
          Reveal / gating behaviour
        </PlaygroundSubSectionTitle>
        <p className="text-xs font-normal text-muted-foreground">
          Toggle autoscroll off to reveal the floating button inside the
          bordered area. Because it lives in a relatively positioned container,
          it anchors to the right edge.
        </p>
        <AutoScrollContext.Provider value={context}>
          <div className="flex items-center gap-4">
            <Button
              variant="outline"
              size="sm"
              onClick={() => setAutoScroll((value) => !value)}
            >
              {autoScrollEnabled ? "Disable autoscroll" : "Enable autoscroll"}
            </Button>
            <div className="relative h-24 w-64 rounded-md border bg-card">
              <FloatingButton />
            </div>
          </div>
        </AutoScrollContext.Provider>
      </PlaygroundSubSectionLayout>
    </PlaygroundSectionLayout>
  );
}
